import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { I18NextPipe } from 'angular-i18next';
import * as _ from 'lodash';
import { NGXLogger } from 'ngx-logger';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { DialogHelpComponent } from 'src/app/common/dialogs/dialog-help/dialog-help.component';
import { ManualRowSortComponent } from 'src/app/dashboards/components/manual-row-sort/manual-row-sort.component';
import { SortComponent } from 'src/app/dashboards/components/sort-component/sort.component';
import { getActiveTabWidgets, getselectedDashboard, getWidgetById, State } from 'src/app/dashboards/state';
import { colorScheme, dataSourceType, labelColorScheme, tableColorScheme, widgetComponentType, widgetType } from 'src/app/enums';
import { gridItem, IHelpDialogData, property } from 'src/app/models';
import { DashboardService } from 'src/app/services/services/dashboard.service';
import { DataTransferService } from 'src/app/services/services/data-transfer.service';
import { EnvironmentService } from 'src/app/services/services/environmet.service';
import { DialogBackComponent } from '../../common/dialogs/dialog-back/dialog-back.component';
import { WidgetContainerComponent } from '../widget/widget-container/widget-container.component';
import { deepCheckObject } from '../widget/widget-helpers/helpers';
import * as actions from './../state/actions';

enum steps {
  // SelectDataSource = 0,
  SelectWidget = 0,
  SelectDataSeries = 1,
  CustomizeYourWidget = 2
}

@Component({
    selector: 'app-widget-wizard',
    templateUrl: './widget-wizard.component.html',
    styleUrls: ['./widget-wizard.component.scss'],
    standalone: false
})
export class WidgetwizardComponent implements OnInit, AfterViewInit {
  isEdit: boolean = false;
  colorSchemeSelectOpened: boolean = false;
  stepSelectDataSeriesComplited: boolean = true;
  public dataEquality: boolean = true;
  public colorSchemeId: number = 0;
  public showPreferences = false;
  public reportsEnabled = false;
  public webEngageRuleMatchEnabled:boolean = false;
  public dataNotifier = new Subject<void>();
  public isOneIdentity = false;
  colorSchemes: property[] = Object.keys(colorScheme).filter(key => isNaN(Number(key))).map(key => ({ id: colorScheme[key], name: key }));
  gridItem: gridItem = {
    cols: 6,
    rows: 6,
    x: 0,
    y: 0,
    componentType: null,
    colorScheme: 0,
    dataSourceType: dataSourceType.Realtime,
    setup: {}
  }
  public selectedOptions = {
    type: null,
    setup: {
      queueIds: [],
      queuePropertiesIds: []
    }
  };
  public periodTypeZero = {
    from: new Date(),
    fromTime: "",
    to: new Date(),
    toTime: "",
    type: 0
  }
  public periodTypeOne = {
    fromDateType: -1,
    fromTime: "",
    fromValue: -1,
    toDateType: -1,
    toTime: "",
    toValue: -1,
    type: 1
  }

  @ViewChild("wcc", { read: WidgetContainerComponent }) public wcc: WidgetContainerComponent;
  @ViewChild('stepper') public stepper: MatStepper;
  constructor(private store: Store<State>, private activatedRoute: ActivatedRoute, private router: Router, public dialog: MatDialog,
    private logger: NGXLogger, private i18nextPipe: I18NextPipe, private dataTransfer: DataTransferService, private DashboardsService: DashboardService) { }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.isEdit && this.gridItem?.setup?.period?.type == 0) {
        this.stepper.selectedIndex = steps.SelectDataSeries;
      } else if (this.isEdit) {
        this.stepper.selectedIndex = steps.CustomizeYourWidget;
      }
      else {
        this.stepper.reset();
      }
    }, 0);
  }

  ngOnInit(): void {
    this.logger.trace('WidgetwizardComponent Init');
    this.DashboardsService.getReportsEnabled().subscribe(enabled => this.reportsEnabled = enabled);
    this.DashboardsService.getWebEngageRuleMatchEnabled().subscribe(enabled => this.webEngageRuleMatchEnabled = enabled);
    this.store.select(getselectedDashboard).pipe(take(1)).subscribe(selectedDash => {
      if (selectedDash == null) {
        this.router.navigate(['/dashboard']);
      }
    })

    let id = this.activatedRoute.snapshot.params.id;
    if (id !== undefined) {
      this.store.select(getWidgetById({ id })).pipe(take(1)).subscribe(gi => {
        if (gi) {
          this.gridItem = JSON.parse(JSON.stringify(gi));
          this.isEdit = true;
        }
      })
    }
    this.isOneIdentity = EnvironmentService.isOneIdentity;
  }

  addWidget(): void {
    if (this.gridItem.id == undefined) {
      this.logger.trace('WidgetwizardComponent: addWidget', this.gridItem);
      this.store.dispatch(actions.addWidget({ gridItem: this.gridItem }));

      this.store.select(getActiveTabWidgets).pipe(take(1)).subscribe(aw => {
        this.dataTransfer.NewAddedWidgetId = aw[aw.length - 1].id
      });
    } else {
      this.logger.trace('WidgetwizardComponent: updateWidget', this.gridItem);
      this.store.dispatch(actions.updateWidget({ gridItem: this.gridItem }));
    }
    this.router.navigate(['/dashboard']);
  }

  backToDashboard(): void {
    const dialogRef = this.dialog.open(DialogBackComponent,
      {
        panelClass: 'dialog-pannel',
        minWidth: '450px',
        disableClose: true,
        data: { dialogText: this.i18nextPipe.transform('dashboard:<div>Are you sure you want to go back </div><div>All set up configurations will not be saved</div>'), backUrl: '/dashboard' }
      });
  }

  onColorSchemeChange($event) {
    if($event && $event.id !== undefined){
      this.colorSchemeId = $event.id;
    }
  }

  showHelp($event, type: widgetComponentType) {
    let data: IHelpDialogData = { title: "", text: "" };

    switch (type) {
      case widgetComponentType.Agents:
        data.title = "Agents Widget";
        data.text = `The agents widget offers more information on one or more selected agents, for key data parameters, associated with each agent.  Some parameters that can be visualized are Average Handle Time, Agent Status, number of offered and answered requests.

This is very useful for getting an overview of one or more key agents within the system - from individual ones, to whole user groups.`;
        break;
      case widgetComponentType.Queues:
        data.title = "Queue Widget";
        data.text = `The queue widget visualizes data for key parameters for one or more selected queues.

The parameters include the number of logged on agents, average wait time, the number of requests in a queue, as well as the offered and answered requests per queue.

This is very useful for getting an overview of one or more important queues within the system.`;
        break;
      case widgetComponentType.Calls:
        data.title = "Traffic Widget";
        data.text = `This widget shows the number of requests offered to queues, as well as the ones answered, per quarter of an hour so far today, in a graph.

The only applicable visualization type for this widget is a graph (bar, line or area), which can be further customized visually. `;
        break;
      case widgetComponentType.Reports:
        data.title = "Historical Widget";
        data.text = `This type of widget offers access to all available Reports, which can be selected and configured as a source, to be visualized as a separate widget on the dashboard.

This is a powerful option, which brings together the customization of the Dashboards solution and the data-richness of the Puzzel reporting system. `;
        break;
      case widgetComponentType.RuleMatch:
        data.title = "Web Engage Widget";
        data.text =this.i18nextPipe.transform( "dashboard:The web engage widget offer statistics based on parameters. Some of the parameters that can be used is Rules and Interactions. A very useful tool to track visitors on the webpage, which rules are triggered most and what interactions are displayed. As well as what time of day are traffic high and low.");
        break;
    }

    let position = $event.currentTarget.getBoundingClientRect();
    let left = window.innerWidth > position.left + 410 ? position.left : position.left - 380
    this.dialog.open(DialogHelpComponent, {
      panelClass: 'dialog-help-pannel',
      backdropClass: "backdrop-invisible",
      data,
      width: "400px",
      position: { top: `${position.top + 30}px`, left: `${left}px` },
    });

  }

  stepperSelectionChange($event) {
    this.logger.trace("WidgetwizardComponent: Stepper selection change", this.gridItem);
    this.showPreferences = false;
    if ($event.previouslySelectedIndex == steps.SelectDataSeries) {
      this.gridItem = this.wcc.gridItem;
    }

    if ($event.previouslySelectedIndex == steps.CustomizeYourWidget) {
      this.dataEquality = true;
    }

    if ($event.selectedIndex == steps.SelectWidget) {
      let hasPeriod = this.gridItem.setup.period ? true : false;
      this.gridItem.setup = Object.assign({});
      this.gridItem.type = null;
      if (hasPeriod) {
        this.gridItem.setup.period = {type: 0, fromTime: '00:00', toTime: '00:00'};
      }
      this.stepSelectDataSeriesComplited = false;
    }

    if (this.gridItem.type != null) {
      if ($event.selectedIndex == steps.CustomizeYourWidget) {
        let container: any = document.getElementsByClassName("widget-container")[0];
        if (this.gridItem.type === widgetType.Label) {
          let width = (this.gridItem.cols / 24) * 100;
          container.style.width = `${width}%`;
        } else {
          container.style.width = `100%`;
        }
      }

      let setup = Object.assign({}, this.gridItem.setup);
      if (this.gridItem.type === 4 && this.gridItem.componentType !== 3) {
        if (!setup.hasOwnProperty(SortComponent.firstLevelSetupColumnPropertyName)) {
          setup[SortComponent.firstLevelSetupColumnPropertyName] = null;
        }
        if (!setup.hasOwnProperty(SortComponent.secondLevelSetupColumnPropertyName)) {
          setup[SortComponent.secondLevelSetupColumnPropertyName] = null;
        }
        if (!setup.hasOwnProperty(SortComponent.firstLevelSetupDirectionPropertyName)) {
          setup[SortComponent.firstLevelSetupDirectionPropertyName] = null;
        }
        if (!setup.hasOwnProperty(SortComponent.secondLevelSetupDirectionPropertyName)) {
          setup[SortComponent.secondLevelSetupDirectionPropertyName] = null;
        }
        if (!setup.hasOwnProperty(ManualRowSortComponent.setupPropertyName)) {
          setup[ManualRowSortComponent.setupPropertyName] = null;
        }

        if (!this.selectedOptions.setup.hasOwnProperty(SortComponent.firstLevelSetupColumnPropertyName)) {
          this.selectedOptions.setup[SortComponent.firstLevelSetupColumnPropertyName] = null;
        }
        if (!this.selectedOptions.setup.hasOwnProperty(SortComponent.secondLevelSetupColumnPropertyName)) {
          this.selectedOptions.setup[SortComponent.secondLevelSetupColumnPropertyName] = null;
        }
        if (!this.selectedOptions.setup.hasOwnProperty(SortComponent.firstLevelSetupDirectionPropertyName)) {
          this.selectedOptions.setup[SortComponent.firstLevelSetupDirectionPropertyName] = null;
        }
        if (!this.selectedOptions.setup.hasOwnProperty(SortComponent.secondLevelSetupDirectionPropertyName)) {
          this.selectedOptions.setup[SortComponent.secondLevelSetupDirectionPropertyName] = null;
        }
        if (!this.selectedOptions.setup.hasOwnProperty(ManualRowSortComponent.setupPropertyName)) {
          this.selectedOptions.setup[ManualRowSortComponent.setupPropertyName] = null;
        }
      }
      let incomingOptions = {
        type: this.gridItem.type,
        setup: setup
      };

      let settingsEquality = deepCheckObject(this.selectedOptions, incomingOptions);
      let dataEquality = deepCheckObject(this.selectedOptions.setup, this.gridItem.setup);
      let periodEquality = true;

      // check periods only for types which settings require definition of period
      if ([widgetComponentType.Reports,
          widgetComponentType.RuleMatch].includes(this.gridItem.componentType)) {
        if (this.gridItem.setup.period.type === 0) {
          periodEquality = _.isEqual(this.periodTypeZero, this.gridItem.setup.period);
          this.periodTypeZero = Object.assign({}, this.gridItem.setup.period);
        } else {
          periodEquality = _.isEqual(this.periodTypeOne, this.gridItem.setup.period);
          this.periodTypeOne = Object.assign({}, this.gridItem.setup.period);
        }
      }

      if (!settingsEquality) {
        if ($event.selectedIndex == steps.CustomizeYourWidget && $event.previouslySelectedIndex == steps.SelectDataSeries) {
          delete this.gridItem.setup.preferences;
        }

        this.gridItem.type !== this.selectedOptions.type && this.selectedOptions.type !== null ?
          this.gridItem.colorScheme = 0 : this.gridItem.colorScheme = this.gridItem.colorScheme;

        this.selectedOptions = Object.assign({}, incomingOptions);
      }

      if (this.gridItem.componentType === widgetComponentType.Reports) {
        if ((!dataEquality || !periodEquality || !settingsEquality) && $event.selectedIndex !== steps.SelectDataSeries) {
          this.dataNotifier.next();
        }
      } else {
        if (!dataEquality || !periodEquality) {
          this.dataNotifier.next();
        }
      }

      switch (this.gridItem.type) {
        case 0:
        case 1:
        case 2:
          this.colorSchemes = Object.keys(colorScheme).filter(key => isNaN(Number(key))).map(key => ({ id: colorScheme[key], name: key }));
          break;
        case 3:
          this.colorSchemes = Object.keys(labelColorScheme).filter(key => isNaN(Number(key))).map(key => ({ id: labelColorScheme[key], name: key }));
          break;
        case 4:
          this.colorSchemes = Object.keys(tableColorScheme).filter(key => isNaN(Number(key))).map(key => ({ id: tableColorScheme[key], name: key }));
      }
    }
  }

  resetSetup(){
    setTimeout(() => {
      this.gridItem.setup = Object.assign({});
    }, 0);
  }
}
